import { render, staticRenderFns } from "./EstadisticasCentros.vue?vue&type=template&id=29519cf6&scoped=true&lang=pug"
import script from "./EstadisticasCentros.vue?vue&type=script&lang=js"
export * from "./EstadisticasCentros.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCentros.vue?vue&type=style&index=0&id=29519cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29519cf6",
  null
  
)

export default component.exports